import React from 'react';
import { Modal, Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { KeepSessionAlive } from '@apps/shared/src/auth/userActions';
import SessionTimeoutModal from './SessionTimeoutModal';

const ModalWrapper = styled(Box)({
  width: '100vw',
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
});

const cardStyles = {
  maxWidth: '25rem',
  margin: 'auto',
};

export interface ChildProps {
  sessionExpired: boolean;
  stayLoggedIn: () => void;
  setShowPopup: React.Dispatch<React.SetStateAction<boolean>>;
  setLastInteraction: React.Dispatch<React.SetStateAction<any>>;
}

function SessionTimeout(props: ChildProps): JSX.Element {
  const stayLoggedIn = () => {
    props.setShowPopup(false);
    props.setLastInteraction(Date.now());
    localStorage.setItem('currentSessionTime', Date.now().toString());
    KeepSessionAlive();
  };

  return (
    <Modal open={props.sessionExpired}>
      <ModalWrapper>
        <SessionTimeoutModal classes={{ card: cardStyles }} stayLoggedIn={stayLoggedIn} />
      </ModalWrapper>
    </Modal>
  );
}

export default SessionTimeout;
